import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import { useContent } from '../hooks/useContent';
import { useScrollToTop } from '../hooks/useScrollToTop';

const ElectricalProducts = () => {
  useScrollToTop();
  const { electricalProducts } = useContent();

  return (
    <SimplePage
      title={electricalProducts.title}
      description={electricalProducts.description}
    />
  );
};

export default ElectricalProducts;